// extracted by mini-css-extract-plugin
export default {"zoomModal":"C1-z","image":"D1-z","button":"E1-z","isOverlayShown":"F1-z"};